import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { KioskOs } from "@biteinc/enums";
//#region src/utils/kiosk_utils.ts
var kiosk_utils_exports = /* @__PURE__ */ __exportAll({
	displayName: () => displayName,
	getTouchCalibrationConfig: () => getTouchCalibrationConfig,
	nextPrefixes: () => nextPrefixes
});
function displayName(data) {
	return data.name || data.serialNumber;
}
const prefixCharacters = [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789"];
const prefixSequence = [...prefixCharacters, ...prefixCharacters.flatMap((first) => prefixCharacters.map((second) => first + second))];
function nextPrefixes(usedPrefixSet, count) {
	const startIndex = prefixSequence.findLastIndex((prefix) => usedPrefixSet.has(prefix)) + 1;
	const prefixes = [];
	for (const candidate of [...prefixSequence.slice(startIndex), ...prefixSequence.slice(0, startIndex)]) {
		if (prefixes.length === count) break;
		if (!usedPrefixSet.has(candidate)) prefixes.push(candidate);
	}
	return prefixes;
}
function getTouchCalibrationConfig(kioskOs, kioskOsVersion) {
	switch (kioskOs) {
		case KioskOs.iOS: return {
			version: 2,
			minTouchDurationThresholdForClick: 250,
			minTouchXYMovementThresholdForClick: 40,
			maxHoldToClickTimeMs: 120
		};
		case KioskOs.Android:
			if ((kioskOsVersion ? Number(kioskOsVersion.match(/([0-9]+)/)[0]) : 8) === 10) return {
				version: 2,
				minTouchDurationThresholdForClick: 240,
				minTouchXYMovementThresholdForClick: 40,
				maxHoldToClickTimeMs: 215
			};
			return {
				version: 2,
				minTouchDurationThresholdForClick: 240,
				minTouchXYMovementThresholdForClick: 40,
				maxHoldToClickTimeMs: 215
			};
		case KioskOs.Tizen: return {
			version: 2,
			minTouchDurationThresholdForClick: 0,
			minTouchXYMovementThresholdForClick: 0,
			maxHoldToClickTimeMs: 750,
			maxFlingDuration: 1e3,
			scrollResponseBoundary: 10,
			scrollBoundary: 20
		};
		default: return {
			version: 2,
			minTouchDurationThresholdForClick: 0,
			minTouchXYMovementThresholdForClick: 0,
			maxHoldToClickTimeMs: 750
		};
	}
}
//#endregion
export { displayName, getTouchCalibrationConfig, kiosk_utils_exports, nextPrefixes };

//# sourceMappingURL=kiosk_utils.js.map